import DeudaDelete from './DeudaDelete'
export {DeudaDelete}
export default DeudaDelete
